
import { Vue, Options } from "vue-class-component";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { getPageGroupTitle, calculateActivePage } from "../utils/pages";
import NavigationModal from "./NavigationModal.vue";
import { calculateProgressIndicatorOffset } from "../utils/modules";

@Options({
  components: {
    FontAwesomeIcon,
    NavigationModal
  },
  props: {
    groups: Object,
    module: Number,
    page: Number,
    language: String
  },
  methods: {
    getPageGroupTitle: getPageGroupTitle
  },
  emits: ["update:page"]
} as any)

export default class Breadcrumbs extends Vue {
  groups: any = [];
  module: any = null;
  page: any = null;
  language: any = null;
  pageState: any = null;
  expanded = false;
  showNavigationModal = false;
  currentGroupProgress = 0;
  progressIndicatorOffset = 0;

  updated() {
    this.currentGroupProgress = this.groups.find((group: any) => this.isCurrentItem(group)).percentage;
    this.updateProgressIndicatorOffset();
    window.addEventListener('resize', this.updateProgressIndicatorOffset);
  }

  beforeUnmount() {
    window.removeEventListener('resize', this.updateProgressIndicatorOffset);
  }

  updateProgressIndicatorOffset() {
    const progressBarWidth = (this.$refs.progressBar as any)[0].clientWidth;
    const progressIndicatorWidth = (this.$refs.progressIndicator as any)[0].offsetWidth;
    this.progressIndicatorOffset = calculateProgressIndicatorOffset(progressBarWidth, progressIndicatorWidth, this.currentGroupProgress);
  }

  navigateToGroup(group:any) {
    this.showNavigationModal = false
    this.groupClick(group)
  }

  async groupClick(group: any) {
    // Click only works when group is "clickable"
    if (group.click) {
      this.pageState = calculateActivePage(group.pages);
      await this.$router.push({
        name: "Page",
        params: {
          moduleId: this.module,
          pageId: this.pageState.pagesId,
          pageStateId: this.pageState.id
        }
      });
      this.expanded = false
      this.$emit("update:page");
    }
  }

  isCurrentItem(group: any) {
    return !!group?.pages?.find((p: any) => p.id == this.page);
  }

  async openNavigationModal() {
    this.showNavigationModal = true
    const el: any = document.getElementById('header')
    el.style.zIndex = "9";
  }

  async closeNavigationModal() {
    this.showNavigationModal = false
  }

}
